import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="animate-fade-up animate-fade-up-4 pb-6 px-4 md:px-0">

            {/* Divider */}
            <div style={{ height: 1, background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.07), transparent)', marginBottom: 28 }} />

            {/* Founder card */}
            <div
                className="glass group transition-shadow duration-300 hover:shadow-[0_10px_36px_rgba(96,165,250,0.08)]"
                style={{ borderRadius: 20, padding: '24px 20px' }}
            >
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">

                    {/* Left — identity */}
                    <div className="flex items-center gap-4 md:gap-5">
                        <div
                            className="transition-transform duration-300 group-hover:scale-105"
                            style={{
                                width: 52,
                                height: 52,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, rgba(96,165,250,0.28), rgba(192,132,252,0.28))',
                                border: '1px solid rgba(255,255,255,0.13)',
                                boxShadow: '0 0 0 4px rgba(96,165,250,0.06), 0 4px 16px rgba(96,165,250,0.12)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 15,
                                fontWeight: 700,
                                fontFamily: 'var(--font-display)',
                                color: '#93c5fd',
                                flexShrink: 0,
                                letterSpacing: '-0.01em',
                            }}
                        >
                            DM
                        </div>

                        <div className="text-left">
                            <div style={{ fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(100,116,139,0.5)', fontFamily: 'var(--font-display)', marginBottom: 4 }}>
                                Built by
                            </div>
                            <div style={{ fontSize: 17, fontWeight: 600, fontFamily: 'var(--font-display)', color: 'rgba(226,232,240,0.92)', letterSpacing: '-0.02em', lineHeight: 1.2 }}>
                                Divyansh Mittal
                            </div>
                            <div style={{ fontSize: 12, color: 'rgba(100,116,139,0.6)', fontFamily: 'var(--font-body)', marginTop: 3 }}>
                                Software Engineer · LeetCoder
                            </div>
                        </div>
                    </div>

                    {/* Right — social buttons */}
                    <div className="grid grid-cols-3 sm:flex sm:flex-row gap-2 sm:gap-3">

                        {/* LinkedIn */}
                        <a
                            href="https://www.linkedin.com/in/divyansh2212/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Divyansh Mittal on LinkedIn"
                            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/50"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 7,
                                padding: '10px 16px',
                                borderRadius: 12,
                                background: 'rgba(10,102,194,0.1)',
                                border: '1px solid rgba(10,102,194,0.22)',
                                color: '#60a5fa',
                                fontSize: 13,
                                fontWeight: 500,
                                fontFamily: 'var(--font-display)',
                                textDecoration: 'none',
                                transition: 'all 0.22s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(10,102,194,0.18)';
                                e.currentTarget.style.borderColor = 'rgba(10,102,194,0.38)';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(10,102,194,0.2)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = 'rgba(10,102,194,0.1)';
                                e.currentTarget.style.borderColor = 'rgba(10,102,194,0.22)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                            </svg>
                            LinkedIn
                        </a>

                        {/* GitHub */}
                        <a
                            href="https://github.com/divyansh2212"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Divyansh Mittal on GitHub"
                            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 7,
                                padding: '10px 16px',
                                borderRadius: 12,
                                background: 'rgba(255,255,255,0.05)',
                                border: '1px solid rgba(255,255,255,0.1)',
                                color: 'rgba(203,213,225,0.85)',
                                fontSize: 13,
                                fontWeight: 500,
                                fontFamily: 'var(--font-display)',
                                textDecoration: 'none',
                                transition: 'all 0.22s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.09)';
                                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.3)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                                <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
                            </svg>
                            GitHub
                        </a>

                        {/* X (Twitter) */}
                        <a
                            href="https://x.com/dbmittal"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Divyansh Mittal on X"
                            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 7,
                                padding: '10px 16px',
                                borderRadius: 12,
                                background: 'rgba(255,255,255,0.05)',
                                border: '1px solid rgba(255,255,255,0.1)',
                                color: 'rgba(203,213,225,0.85)',
                                fontSize: 13,
                                fontWeight: 500,
                                fontFamily: 'var(--font-display)',
                                textDecoration: 'none',
                                transition: 'all 0.22s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.09)';
                                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.3)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.74l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg>
                            X
                        </a>

                        {/* LeetCode */}
                        <a
                            href="https://leetcode.com/u/divyansh2212/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Divyansh Mittal on LeetCode"
                            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 7,
                                padding: '10px 16px',
                                borderRadius: 12,
                                background: 'rgba(255,161,22,0.1)',
                                border: '1px solid rgba(255,161,22,0.22)',
                                color: '#ffa116',
                                fontSize: 13,
                                fontWeight: 500,
                                fontFamily: 'var(--font-display)',
                                textDecoration: 'none',
                                transition: 'all 0.22s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(255,161,22,0.18)';
                                e.currentTarget.style.borderColor = 'rgba(255,161,22,0.38)';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(255,161,22,0.2)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = 'rgba(255,161,22,0.1)';
                                e.currentTarget.style.borderColor = 'rgba(255,161,22,0.22)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                                <path d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104 5.35 5.35 0 0 0-.125.513 5.527 5.527 0 0 0 .062 2.362 5.83 5.83 0 0 0 .349 1.017 5.938 5.938 0 0 0 1.271 1.818l4.277 4.193.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523 2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382 1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382 1.38 1.38 0 0 0-1.38-1.382z" />
                            </svg>
                            LeetCode
                        </a>

                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div
                className="flex items-center justify-center gap-1.5"
                style={{ marginTop: 16, fontSize: 11, color: 'rgba(100,116,139,0.45)', fontFamily: 'var(--font-body)', textAlign: 'center' }}
            >
                <span>© {new Date().getFullYear()} RoundPrep · Made with</span>
                <Heart size={11} className="text-rose-400/70" fill="currentColor" />
                <span>by Divyansh Mittal</span>
            </div>

        </footer>
    );
};

export default Footer;